import { render } from "./Gtc.vue?vue&type=template&id=131b7924"
import script from "./Gtc.vue?vue&type=script&lang=js"
export * from "./Gtc.vue?vue&type=script&lang=js"

import "./Gtc.vue?vue&type=style&index=0&id=131b7924&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__